define('DefineFalse', [

], function(

) {
    return {
        mountToApp: function mountToApp(application) {
            application.getLayout().on('beforeAppendView', function() {
                console.log('__removing amd');
                define.amd = false;
            });
        }
    };
});

